// extracted by mini-css-extract-plugin
module.exports = {"slider":"Slider_slider__3kVKd","range":"Slider_range__3rdc-","handle":"Slider_handle__lo81c","compressedSlider":"Slider_compressedSlider__2kYF0"};